import React from 'react';
import { useOverviewDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/store/overviewDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';

export const CallOutByLocationChart: React.FC = () => {
  const callOutByLocation = useOverviewDashboardStore((s) => s.callOutByLocation);
  const page = useOverviewDashboardStore((s) => s.callOutByLocationPage);
  const totalPages = useOverviewDashboardStore((s) => s.callOutByLocationTotalPages);
  const loadingMore = useOverviewDashboardStore((s) => s.callOutByLocationLoadingMore);
  const loadMore = useOverviewDashboardStore((s) => s.loadMoreCallOutByLocation);
  const palette = useChartColors();

  if (!callOutByLocation || callOutByLocation.length === 0) {
    return (
      <EmptyStateContainer>
        No call out data available for the selected filters.
      </EmptyStateContainer>
    );
  }

  const barColor = palette.chartColors[3];

  const items: HorizontalBarItem[] = callOutByLocation.map((d) => ({
    label: d.locationName,
    value: d.callOutCount,
    valueLabel: d.callOutCount.toLocaleString(),
    ariaLabel: `${d.locationName}: ${d.callOutCount} call out shifts`,
    tooltipHtml: `<strong>${
      d.locationName
    }</strong><br/>Call out shifts: ${d.callOutCount.toLocaleString()}`,
    barColor,
  }));

  return (
    <HorizontalBarChart
      items={items}
      leftMargin={170}
      rightMargin={0}
      showTrack={false}
      wrapLabels
      scrollable
      ariaLabel="Call out volume by location chart showing call out shift count per location"
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
